import { render, staticRenderFns } from "./PlcFieldDialog.vue?vue&type=template&id=b52e31ec"
import script from "./PlcFieldDialog.vue?vue&type=script&lang=js"
export * from "./PlcFieldDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports